import MultiResolutionImage from './multi-resolution-image';
import MultiResolutionBackgroundDiv from './multi-resolution-background-div';
import MultiResolutionResponsiveImage from './multi-resolution-responsive-image';
export default MultiResolutionImage;
export { MultiResolutionBackgroundDiv, MultiResolutionResponsiveImage };